import Image from 'next/image';
import React, { useEffect } from 'react';

export default function free3Box(props) {

  useEffect(() => {
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);

  const handleClick = (e, data, c, d) => {
    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '상단영역_자유형(3개)',
        clickType: 'NC',
        value1: data.pc_img_attr,
        value2: '',
        value3: '',
        value4: '',
        value5: '',
      },
    });
  };

  const renderContent = (content, idx, type, isLarge = false) => {
    const isNoTitle = !content.title;
    const wrapClass = isLarge
        ? `spotModuleWrap_freeType1 spotModuleWrap_ContentPhoto ${isNoTitle ? 'type_noText' : ''}`
        : `spotModuleWrap_freeType1-1 spotModuleWrap_ContentPhoto ${isNoTitle ? 'spotModuleWrap_freeTypeBnr' : ''}`;

    const imageHeight = isLarge ? 450 : 213;

    return (
        <div className={wrapClass}>
          {
            !content.link_url ? (
                <div className="spotModuleLink">
              <span className="spotModuleImage_w">
                <Image
                    src={content.pc_img_url}
                    className="spotModuleImg"
                    layout="fixed"
                    width={588}
                    height={imageHeight}
                    quality={content.imageQuality || 75}
                    alt={content.pc_img_attr}
                />
              </span>
                  <div className="spotProgramCont">
                    <strong className="spotProgram-Title" style={{ whiteSpace: 'pre-line' }}>
                      {content.title}
                    </strong>
                  </div>
                </div>
            ) : (
                <a
                    href={content.link_url}
                    onClick={(e) => handleClick(e, content, type, `${idx + 1}`)}
                    target={content.link_new_yn === 'Y' ? '_blank' : undefined}
                    rel={content.link_new_yn === 'Y' ? 'noopener noreferrer' : undefined}
                    className="spotModuleLink"
                >
              <span className="spotModuleImage_w">
                <Image
                    src={content.pc_img_url}
                    className="spotModuleImg"
                    layout="fixed"
                    width={588}
                    height={imageHeight}
                    quality={content.imageQuality || 75}
                    alt={content.pc_img_attr}
                />
              </span>
                  <div className="spotProgramCont">
                    <strong className="spotProgram-Title" style={{ whiteSpace: 'pre-line' }}>
                      {content.title}
                    </strong>
                  </div>
                </a>
            )
          }
        </div>
    );
  };

  return (
      <div className="swiper-slide slide-slide">
        <div className="swiper-cont">
          <div className="spotModuleGroup2">
            <div className="spotModuleGroup2-2">
              {renderContent(props.data.contents[0], 0, '3free')}
              {renderContent(props.data.contents[1], 1, '3free22')}
            </div>
            {renderContent(props.data.contents[2], 2, '3free', true)}
          </div>
        </div>
      </div>
  );
}
